import { useNavigate, useLocation } from "react-router-dom";
import SwitchToggle from "../../components/SwitchToggle";
import { ProductItem } from "../../store/api/manageAPI";
import { PRODUCT_TYPE, VARIANT_TYPE } from "../../constants/enums";
import Loader from "../../constants/Loader";
import { useState } from "react";

const ManageProductsDetail = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const product = location.state?.product as ProductItem | undefined;

  const [isLoading] = useState(false);

  if (!product) {
    return (
      <>
        <Loader isLoad={isLoading} />
        <div className="main_title">
          <h1>Product Detail</h1>
          <p>
            <button onClick={() => navigate("/dashboard")}>Dashboard</button> -{" "}
            <button onClick={() => navigate("/manage-products")}>Manage Products</button> - Product Detail
          </p>
        </div>
        <div className="cards view_page">
          <p>Product not found. Please go back and try again.</p>
        </div>
      </>
    );
  }

  // Format date
  const formattedDate = product.createdAt
    ? new Date(product.createdAt).toLocaleDateString("en-GB", {
        day: "2-digit",
        month: "short",
        year: "numeric",
      })
    : "N/A";

  // Determine type display
  const typeDisplay =
    product.type === PRODUCT_TYPE.SIZE
      ? `Size: ${product.size || "N/A"}`
      : product.type === PRODUCT_TYPE.VARIANT
      ? product.variant === VARIANT_TYPE.SINGLE
        ? "Single Variant"
        : product.variant === VARIANT_TYPE.DOUBLE
        ? "Double Variant"
        : "Variant"
      : "N/A";

  // Format price display
  const getPriceDisplay = () => {
    if (product.type === PRODUCT_TYPE.SIZE) {
      return `${product.price?.toFixed(3) || "0.000"} OMR`;
    } else if (product.type === PRODUCT_TYPE.VARIANT) {
      if (product.variant === VARIANT_TYPE.SINGLE) {
        return `${product.price?.toFixed(3) || "0.000"} OMR`;
      } else if (product.variant === VARIANT_TYPE.DOUBLE) {
        return (
          <>
            <strong>Single:</strong> {product.price?.toFixed(3) || "0.000"} OMR
            <br />
            <strong>Double:</strong> {product.doublePrice?.toFixed(3) || "0.000"} OMR
          </>
        );
      }
    }
    return "N/A";
  };

  return (
    <>
      <Loader isLoad={isLoading} />
      <div className="main_title">
        <h1>Product Detail</h1>
        <p>
          <button onClick={() => navigate("/dashboard")}>Dashboard</button> -{" "}
          <button onClick={() => navigate("/manage-products")}>Manage Products</button> - Product Detail
        </p>
      </div>

      <div className="cards view_page">
        <div className="gap_p">
          <div className="vew_img v2 no_radius w_100">
            <h6>Product Image</h6>
            <figure>
              <img
                alt="product"
                src={
                  product.image?.startsWith("http")
                    ? product.image
                    : product.image
                    ? `/static/images/${product.image}`
                    : "/static/images/placeholder.png"
                }
                onError={(e) => {
                  (e.target as HTMLImageElement).src = "/static/images/placeholder.png";
                }}
              />
            </figure>
          </div>

          <div className="w_33">
            <h6>Product Name</h6>
            <p>{product.name || "N/A"}</p>
          </div>

          <div className="w_33">
            <h6>Category</h6>
            <p>{product.categoryDetails?.name || "N/A"}</p>
          </div>

          <div className="w_33">
            <h6>Type</h6>
            <p>{typeDisplay}</p>
          </div>

          <div className="w_33">
            <h6>Price</h6>
            <p>{getPriceDisplay()}</p>
          </div>

          <div className="w_33">
            <h6>Created Date</h6>
            <p>{formattedDate}</p>
          </div>

          <div className="w_33">
            <h6>Status</h6>
            <SwitchToggle checked={product.isActive ?? true} />
          </div>

          {product.ingredients && (
            <div className="w_100">
              <h6>Ingredients</h6>
              <p>{product.ingredients}</p>
            </div>
          )}

          {product.description && (
            <div className="w_100">
              <h6>Description</h6>
              <p>{product.description}</p>
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default ManageProductsDetail;
